<div class="container-scroller">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper auth">
      <div class="auth-form desktop">
        <div class="brand-logo">
          <img src="assets/img/OpStoom_logo_30-jaar.svg" alt="Logo" />
        </div>

        <h4 class="title">{{ "resetPassword.title" | translate }}</h4>
        <h6 class="subtitle instruction">
          {{ "resetPassword.instruction" | translate }}
        </h6>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <input
              type="password"
              formControlName="password"
              placeholder="{{ 'resetPassword.newPassword' | translate }}"
              class="form-control" />
               <messages
            class="msg"
            [form]="form"
            [messagesObserver]="messages"
            fieldname="password">
          </messages>
          </div>

          <div class="form-group">
            <input
              type="password"
              formControlName="confirmPassword"
              placeholder="{{ 'resetPassword.confirmPassword' | translate }}"
              class="form-control" />
               <messages
            class="msg"
            [form]="form"
            [messagesObserver]="messages"
            fieldname="confirmPassword">
          </messages>
          </div>

          <div class="action-buttons">
            <action-button
              (actionEvent)="onSubmit($event)"
              label="{{ 'resetPassword.save' | translate }}">
              <span class="material-icons-outlined">save</span>
              {{ "resetPassword.save" | translate }}
            </action-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
